import { useCallback, useState } from "react";
import { WizardMessage } from "../types";
import { WIZARD_DELAYS } from "../constants";

interface UseWizardMessagesProps {
  userId: number | undefined;
}

export const useWizardMessages = ({ userId }: UseWizardMessagesProps) => {
  const [messages, setMessages] = useState<WizardMessage[]>([]);
  const [isBotTyping, setIsBotTyping] = useState(false);

  const addBotMessage = useCallback(
    (
      content: string,
      options?: {
        wizardType?: WizardMessage["wizardType"];
        component?: React.ReactNode;
        actions?: WizardMessage["actions"];
        delay?: number;
      },
    ) => {
      setIsBotTyping(true);

      setTimeout(() => {
        const newMessage: WizardMessage = {
          id: Date.now(),
          chatId: 1,
          senderId: 0, // Bot
          content,
          type: "text",
          timestamp: new Date(),
          status: "sent",
          wizardType: options?.wizardType || "question",
          component: options?.component,
          actions: options?.actions,
        };
        setMessages((prev) => [...prev, newMessage]);
        setIsBotTyping(false);
      }, options?.delay || WIZARD_DELAYS.BOT_TYPING);
    },
    [],
  );

  const addUserMessage = useCallback(
    (content: string) => {
      const newMessage: WizardMessage = {
        id: Date.now() + 1,
        chatId: 1,
        senderId: userId || 1,
        content,
        type: "text",
        timestamp: new Date(),
        status: "sent",
      };
      setMessages((prev) => [...prev, newMessage]);
    },
    [userId],
  );

  const clearMessages = useCallback(() => {
    setMessages([]);
    setIsBotTyping(false);
  }, []);

  return {
    messages,
    isBotTyping,
    addBotMessage,
    addUserMessage,
    clearMessages,
  };
};
